import { IComponentOptions } from 'angular';
import { SideNavMenuCtrl } from './side-nav-menu.controller';

export const SideNavMenuComponent: IComponentOptions = {
  template: require('./side-nav-menu.html'),
  controller: SideNavMenuCtrl,
  controllerAs: '$ctrl',
  bindings: {
    currentUser: '<',
  },
};

angular.module('nv.directives').component('nvSideNavMenu', SideNavMenuComponent);
